"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunk2VCHSK65_js = require('./chunk-2VCHSK65.js');
var react = require('react');
var e = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var e__default = /*#__PURE__*/_interopDefaultLegacy(e);

var a=e__default["default"].label`
  display: flex;
  align-items: center;
`,l=e__default["default"](chunk2VCHSK65_js.d)`
  color: var(--foreground-primary);
`,p=e__default["default"](chunk2VCHSK65_js.d)`
  padding-left: var(--spacing-x-small);
  color: var(--foreground-primary);
`,n=e__default["default"].span`
  padding-left: var(--spacing-regular);
`;var i=react.forwardRef(({children:s,interaction:t,optional:b=!1,...d},f)=>jsxRuntime.jsxs(a,{...d,ref:f,children:[jsxRuntime.jsx(l,{weight:"bold",children:s}),b&&jsxRuntime.jsx(p,{children:"(optional)"}),t&&jsxRuntime.jsx(n,{children:t})]}));i.displayName="Label";var c=e__default["default"](i)``;

exports.a = c;
